<div class="govuk-width-container">
    <main class="govuk-main-wrapper">

        <div class="govuk-grid-row">
            <div class="govuk-grid-column-two-thirds">
                <h1 class="govuk-heading-l">Login
                </h1>
            </div>

        </div>
        <h1 class="govuk-heading-m" [innerHtml]="dataStore.company?.extra?.access_page_sub_title"></h1>
        <hr /><br />

        <!-- login -->
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" *ngIf="!sso">

            <p *ngIf="invalidLogin" id="email-error" class="govuk-error-message">
                <span class="govuk-visually-hidden">Error:</span>Your email and/or password was not recognised. Please try again.
            </p>

            <fieldset class="govuk-fieldset">
                <div class="govuk-form-group">
                    <h4 class="govuk-heading-m">
                        <label for="email-form">Email</label>
                    </h4>
                    <div *ngIf="form.email.errors">
                        <p *ngIf="submitted && form.email.errors.pattern" id="email-error" class="govuk-error-message">
                            <span class="govuk-visually-hidden">Error:</span> Please enter a valid email address
                        </p>
                        <p *ngIf="submitted && form.email.errors.required" id="email-error" class="govuk-error-message">
                            <span class="govuk-visually-hidden">Error:</span> Email required
                        </p>
                    </div>
                    <input class="govuk-input govuk-!-width-two-thirds" id="email-form" name="email-form" type="text"
                        autocomplete="email" formControlName="email" tabindex="0" role="textbox">
                </div>

                <div class="govuk-form-group govuk-password-input" data-module="govuk-password-input">
                    <h4 class="govuk-heading-m" for="password-form">
                        <label for="password-form">Password</label>
                    </h4>
                    <p *ngIf="submitted && form.password.errors" id="password-error" class="govuk-error-message">
                        <span class="govuk-visually-hidden">Error:</span> password required
                    </p>
                    <div class="govuk-input__wrapper govuk-password-input__wrapper">
                      <input [type]="showPassword ? 'text' : 'password'" formControlName="password" class="govuk-input govuk-!-width-two-thirds govuk-password-input__input govuk-js-password-input-input" id="password-input" name="password" spellcheck="false" autocomplete="current-password" autocapitalize="none">
                      <button style="margin-left: 5px;" *ngIf="!showPassword" (click)="togglePasswordVisibility()" type="button" class="govuk-button govuk-button--secondary govuk-password-input__toggle govuk-js-password-input-toggle" data-module="govuk-button" aria-controls="password-input" aria-label="Show password" hidden>
                        Show
                      </button>
                      <button style="margin-left: 5px;" *ngIf="showPassword" (click)="togglePasswordVisibility()" type="button" class="govuk-button govuk-button--secondary govuk-password-input__toggle govuk-js-password-input-toggle" data-module="govuk-button" aria-controls="password-input" aria-label="Show password" hidden>
                        Hide
                      </button>
                    </div>
                  </div>

                <button class="govuk-button" data-module="govuk-button" type="submit">
                    Login
                </button>
            </fieldset>
        </form>

        <button class="govuk-button" data-module="govuk-button" type="submit" (click)="login()" >
            Sign in via Microsoft
        </button>

<!--         <span class="govuk-error-message forgot-password" (click)="forgotPasswordToggle()">Forgot your password?</span>
        <br />
        <br />
        <form [formGroup]="resetPasswordForm">
            <fieldset *ngIf="forgotPassword" class="govuk-fieldset">
                <input class="govuk-input govuk-!-width-two-thirds" id="reset-email-form" name="reset-email-form"
                    type="text" autocomplete="email" placeholder="Enter email address" formControlName="resetemail"
                    tabindex="0" role="textbox">
                <br />
                <div *ngIf="resetForm.resetemail.errors">
                    <p *ngIf="resetSubmitted && resetForm.resetemail.errors.pattern" id="email-error"
                        class="govuk-error-message">
                        <span class="govuk-visually-hidden">Error:</span> {{'COMMON.FORMS.VALIDATION.EMAIL_INVALID'
                        |
                        translate}}
                    </p>
                    <p *ngIf="resetSubmitted && resetForm.resetemail.errors.required" id="email-error"
                        class="govuk-error-message">
                        <span class="govuk-visually-hidden">Error:</span> {{'COMMON.FORMS.VALIDATION.EMAIL_REQUIRED'
                        |
                        translate}}
                    </p>
                </div>
                <br />
                <button class="govuk-button" data-module="govuk-button" (click)="sendReset()">
                    Send password reset
                </button>
                <br />
                <span class="govuk-error-message forgot-password-success" *ngIf="resetSuccess">If your email exists, you
                    will receive a password reset email
                    shortly</span>
            </fieldset>

        </form> -->

    </main>
</div>
